import { LoadingOutlined, WarningTwoTone, CheckCircleTwoTone } from '@ant-design/icons';

import { Space, Typography } from 'antd';

import { UI_JOB_STATUS } from './BulkUploaderUtils';

// danger
// success
// warning
const SOInfoMessage = ({ status, message, type }) => {
  // TODO: add other status
  const map = {
    [UI_JOB_STATUS.errorOnExecution]: {
      type: 'danger',
      icon: <WarningTwoTone twoToneColor="red" />,
      text: message ?? 'Error while executing the job, Please upload again!'
    },
    [UI_JOB_STATUS.validating]: {
      type: 'secondary',
      icon: <LoadingOutlined />,
      text: ''
    },
    [UI_JOB_STATUS.submitting]: {
      type: 'secondary',
      icon: <LoadingOutlined />,
      text: ''
    },
    [UI_JOB_STATUS.requestReceived]: {
      type: 'secondary',
      icon: <LoadingOutlined />,
      text: ''
    },
    [UI_JOB_STATUS.submitted]: {
      type: 'secondary',
      icon: <CheckCircleTwoTone className="checked_two_tone_background" twoToneColor="green" />,
      text: `New Bulk SO ${type} Request created successfully.`
    },
    [UI_JOB_STATUS.validationFailed]: {
      type: 'danger',
      icon: <WarningTwoTone twoToneColor="red" />,
      text: 'Validation Failed please download files to check errors!'
    }
  };

  if (!map[status]) {
    return null;
  }
  return (
    <Space>
      {map[status]?.icon} <Typography.Text type={map[status].type}>{map[status].text}</Typography.Text>
    </Space>
  );
};

export default SOInfoMessage;
